import { Module } from 'vuex';
// const TOKEN = 'a59bff874d9768c4da3cb24cfab9d478cbeb0d3a';
import { RootState, StockSearchState, ProductoLegacy } from '../../models/Stock';
import axios from 'axios';
//============================= Configuración axios =========================================//
// Helper axios local (mismo archivo)
// const http = axios.create({
// 	baseURL: '/',
// 	headers: { 'Content-Type': 'application/json' },
// 	validateStatus: () => true,
// });
// Soporte de cancelación para axios
function withCancel(signal?: AbortSignal) {
	if (!signal) return {};
	const CancelToken = (axios as any).CancelToken;
	if (CancelToken) {
		const src = CancelToken.source();
		signal.addEventListener('abort', () => src.cancel('aborted'));
		return { signal, cancelToken: src.token };
	}
	return { signal };
}
//=================================== Los Headers que necesitan los CGI ===================================//
// function authHeaders() {
// 	return {
// 		'Content-Type': 'application/json',
// 		Authorization: `Bearer ${TOKEN}`,
// 	};
// }
//=================================== STATE ===================================//
const state = (): StockSearchState => ({
	items: [],
	isSearching: false,
	lastQuery: '',
	_inflight: null,
});
//=================================== GETTERS ===================================//
const getters = {
	items: s => s.items,
	isSearching: s => s.isSearching,
};
//=================================== MUTATIONS ===================================//
const mutations = {
	SET_SEARCHING(s, v: boolean) {
		s.isSearching = !!v;
	},
	SET_ITEMS(s, list: ProductoLegacy[]) {
		s.items = Array.isArray(list) ? list : [];
	},
	SET_LAST_QUERY(s, q: string) {
		s.lastQuery = q || '';
	},
	SET_INFLIGHT(s, c: AbortController | null) {
		s._inflight = c;
	},
	RESET(s) {
		s.items = [];
		s.isSearching = false;
		s.lastQuery = '';
		s._inflight = null;
	},
};
//=================================== ACTIONS ===================================//
const actions = {
	// Buscar productos por descripción (mínimo 3 caracteres)
	async fetchByDescri({ commit, state }, descri: string) {
		const q = (descri || '').trim();
		commit('SET_LAST_QUERY', q);

		if (q.length < 3) {
			try {
				state._inflight && state._inflight.abort();
			} catch {}
			commit('SET_ITEMS', []);
			commit('SET_SEARCHING', false);
			commit('SET_INFLIGHT', null);
			return;
		}

		// cancelar anterior y crear nuevo AbortController
		try {
			state._inflight && state._inflight.abort();
		} catch {}
		const ctrl = new AbortController();
		commit('SET_INFLIGHT', ctrl);
		commit('SET_SEARCHING', true);

		try {
			const body = { codemp: 1, grudep: 1, descri: q, usrid: '8888' };
			const { data } = await axios.post('./api/public/proxy/cgi/consultarStock', body, {
				// headers: authHeaders(),
				...withCancel(ctrl.signal),
				validateStatus: () => true,
			});

			if (state._inflight !== ctrl) return;
			const list = Array.isArray(data && data.items) ? data.items : [];
			commit('SET_ITEMS', list);
		} catch (e) {
			if (state._inflight === ctrl) commit('SET_ITEMS', []);
		} finally {
			if (state._inflight === ctrl) {
				commit('SET_SEARCHING', false);
				commit('SET_INFLIGHT', null);
			}
		}
	},
	// Buscar producto por código de barras (retorna 1 solo producto o null)
	async fetchByBarcode({ commit }, barcode: string): Promise<ProductoLegacy | null> {
		const code = String(barcode || '').trim();
		if (!code) return null;

		try {
			const body = { codemp: 1, grudep: 1, barcode: code, usrid: '8888' };
			const { data } = await axios.post('./api/public/proxy/cgi/consultarStock', body, {
				// headers: authHeaders(),
				validateStatus: () => true,
			});
			const list: ProductoLegacy[] = Array.isArray(data && data.items) ? data.items : [];
			commit('SET_ITEMS', list);
			return list.length ? list[0] : null;
		} catch {
			commit('SET_ITEMS', []);
			return null;
		}
	},
	// Confirmar stock (modificar + confirmar)
	async confirmarStock(_, payload: { codalfa: string; cantidad: number; codemp?: number; coddep?: number }): Promise<void> {
		const { codalfa, cantidad, codemp = 1, coddep = 1 } = payload;
		const usrid = '8888';
		if (!codalfa) throw new Error('Falta codalfa');
		if (Number.isNaN(Number(cantidad)) || Number(cantidad) < 0) throw new Error('Cantidad inválida');

		// 1) modificar
		const r1 = await axios.post(
			'./api/public/proxy/cgi/modificarStock',
			{ codalfa, cantidad: Number(cantidad), codemp, coddep, usrid },
			{ validateStatus: () => true }
			// 	{
			// 		headers: authHeaders(),
			// 	}
		);
		if (r1.status < 200 || r1.status >= 300)
			throw new Error(`modificarStock: HTTP ${r1.status} ${typeof r1.data === 'string' ? r1.data : JSON.stringify(r1.data).slice(0, 200)}`);

		// 2) confirmar
		const r2 = await axios.post(
			'./api/public/proxy/cgi/confirmarStock',
			{ codalfa, codemp, coddep, usrid },
			{ validateStatus: () => true }
			// {
			// 	headers: authHeaders(),
			// }
		);
		if (r2.status < 200 || r2.status >= 300)
			throw new Error(`confirmarStock: HTTP ${r2.status} ${typeof r2.data === 'string' ? r2.data : JSON.stringify(r2.data).slice(0, 200)}`);
	},
	// Cancelar búsqueda en curso
	cancelSearch({ state, commit }) {
		try {
			state._inflight && state._inflight.abort();
		} catch {}
		commit('SET_ITEMS', []);
		commit('SET_SEARCHING', false);
		commit('SET_INFLIGHT', null);
	},
	// Resetear todo
	reset({ commit }) {
		commit('RESET');
	},
};

const stock: Module<StockSearchState, RootState> = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};

export default stock;
